const isShowTaotie = (state = false, action) => {
  switch (action.type) {
    case 'SET_SHOW_TAOTIE':
      return action.isShowTaotie;
    default:
      return state;
  }
};

const  isShowTaotieSwing = (state = false, action) => {
  switch (action.type) {
    case 'SET_SHOW_TAOTIE_SWING':
      return action.isShowTaotieSwing;
    default:
      return state;
  }
};

const propertyTransAnim = (state = {}, action) => {
  switch (action.type) {
    case 'SHOW_PROPERTY_TRANS_ANIM':
      return action.propertyTransAnim;
    default:
      return state;
  }
};


export { isShowTaotie, isShowTaotieSwing, propertyTransAnim };

